import uniq from "lodash/uniq";

import { PaymentMethod } from "constants/payments";

import { EMPTY_ARRAY } from "lib";

import { createLookupCombiner, createLookupSelectors } from "./lib";

import { getPayments } from "./root";
import {
  selectPaymentIdsByBillingDocumentIdLookup,
  selectPaymentIdsByFromBusinessIdLookup,
} from "./indexes";

export const getPaymentById =
  (paymentId: string) =>
  (state: State): Payment | null =>
    getPayments(state)[paymentId] || null;

export const getPaymentIdsByFromBusinessId =
  (fromBusinessId: string) => (state: State) =>
    selectPaymentIdsByFromBusinessIdLookup(state)[fromBusinessId] || null;

export const getPaymentIdsByBillingDocumentId =
  (billingDocumentId: string) => (state: State) =>
    selectPaymentIdsByBillingDocumentIdLookup(state)[billingDocumentId] || null;

export const [
  selectPaymentsByBillingDocumentIdLookup,
  getPaymentsByBillingDocumentId,
] = createLookupSelectors(
  [selectPaymentIdsByBillingDocumentIdLookup, getPayments],
  createLookupCombiner(
    (paymentIds: string[], paymentByIdLookup: Record<string, Payment>) =>
      paymentIds.map((paymentId: string) => paymentByIdLookup[paymentId]),
  ),
) as [
  (state: State) => Record<string, Payment[]>,
  (billingDocumentId: string) => (state: State) => Payment[] | null,
];

export const [selectPaymentMethodsByBuyerIdLookup, getPaymentMethodsByBuyerId] =
  createLookupSelectors(
    [selectPaymentIdsByFromBusinessIdLookup, getPayments],
    createLookupCombiner(
      (
        paymentIds: string[],
        paymentByIdLookup: Record<string, Payment>,
      ): PaymentMethod[] =>
        uniq(
          paymentIds
            .map(paymentId => paymentByIdLookup[paymentId]?.paymentMethod)
            .filter((method): method is PaymentMethod => Boolean(method)),
        ),
    ),
    EMPTY_ARRAY,
  ) as [
    (state: State) => Record<string, PaymentMethod[]>,
    (buyerId: string) => (state: State) => PaymentMethod[],
  ];
